module.exports = __webpack_public_path__ + "static/media/contactus_illustration.8045611f.svg";